import { z } from 'zod'

import { LinkExternalDtoSchema } from '../common'
import { AccordionDtoSchema, CardPromotionDtoSchema, CarouselDtoSchema, PricingDtoSchema } from '../components'

export const ServiceDetailsDtoSchema = z.strictObject({
  destinationId: z.string(),
  serviceId: z.string(),
  imageUrl: z.string().url(),
  title: z.string(),
  description: z.string(),
  link: LinkExternalDtoSchema.nullable(),
  content: z.array(z.union([AccordionDtoSchema, CardPromotionDtoSchema, CarouselDtoSchema, PricingDtoSchema])),
})

export type ServiceDetailsDto = z.infer<typeof ServiceDetailsDtoSchema>

export const isServiceDetailsDto = (x: unknown): x is ServiceDetailsDto => ServiceDetailsDtoSchema.safeParse(x).success
